import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import api from "../api/axios";
import { useAuth } from "../context/AuthContext";
import PublicNav from "../components/PublicNav";

/* ═══════════════════════════════════════
   COULEURS SETRAG
═══════════════════════════════════════ */
const C = {
  green:    "#006B3C",
  greenDk:  "#004D2B",
  greenLt:  "#E8F5EE",
  greenMid: "#00894D",
  yellow:   "#FFC300",
  yellowLt: "#FFF8DC",
  white:    "#FFFFFF",
  gray:     "#F5F5F5",
  grayBd:   "#E0E0E0",
  text:     "#1A1A1A",
  textSub:  "#666666",
};

/* ═══════════════════════════════════════
   ICONS
═══════════════════════════════════════ */
const UserIcon   = () => <svg width="14" height="14" viewBox="0 0 16 16" fill="none"><circle cx="8" cy="5" r="3" stroke={C.textSub} strokeWidth="1.5"/><path d="M2 13c0-2.8 2.7-5 6-5s6 2.2 6 5" stroke={C.textSub} strokeWidth="1.5" strokeLinecap="round"/></svg>;
const MailIcon   = () => <svg width="14" height="14" viewBox="0 0 16 16" fill="none"><rect x="1" y="3" width="14" height="10" rx="2" stroke={C.textSub} strokeWidth="1.5"/><path d="M1 6l7 4 7-4" stroke={C.textSub} strokeWidth="1.5"/></svg>;
const PhoneIcon  = () => <svg width="14" height="14" viewBox="0 0 16 16" fill="none"><path d="M3 1h4l1.5 4-2 1.2a9.1 9.1 0 004.3 4.3L12 8.5 16 10v4a2 2 0 01-2 2A15 15 0 011 3a2 2 0 012-2z" stroke={C.textSub} strokeWidth="1.5" strokeLinejoin="round"/></svg>;
const LockIcon   = () => <svg width="14" height="14" viewBox="0 0 16 16" fill="none"><rect x="3" y="7" width="10" height="8" rx="2" stroke={C.textSub} strokeWidth="1.5"/><path d="M5 7V5a3 3 0 016 0v2" stroke={C.textSub} strokeWidth="1.5"/></svg>;
const EyeIcon    = () => <svg width="14" height="14" viewBox="0 0 16 16" fill="none"><path d="M1 8s2.5-5 7-5 7 5 7 5-2.5 5-7 5-7-5-7-5z" stroke={C.textSub} strokeWidth="1.5"/><circle cx="8" cy="8" r="2" stroke={C.textSub} strokeWidth="1.5"/></svg>;
const EyeOffIcon = () => <svg width="14" height="14" viewBox="0 0 16 16" fill="none"><path d="M2 2l12 12M6.5 6.6A2 2 0 0010 10M4 4.3C2.4 5.4 1 8 1 8s2.5 5 7 5c1.4 0 2.7-.4 3.8-1M7 3.1C7.3 3 7.6 3 8 3c4.5 0 7 5 7 5s-.6 1.2-1.6 2.3" stroke={C.textSub} strokeWidth="1.5" strokeLinecap="round"/></svg>;
const AlertIcon  = () => <svg width="14" height="14" viewBox="0 0 16 16" fill="none" style={{ flexShrink:0 }}><circle cx="8" cy="8" r="7" stroke="#f87171" strokeWidth="1.5"/><path d="M8 5v4M8 11v.5" stroke="#f87171" strokeWidth="1.5" strokeLinecap="round"/></svg>;
const CheckIcon  = () => <svg width="14" height="14" viewBox="0 0 16 16" fill="none" style={{ flexShrink:0 }}><circle cx="8" cy="8" r="7" stroke={C.green} strokeWidth="1.5"/><path d="M5 8l2 2 4-4" stroke={C.green} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>;
const SpinIcon   = () => <span style={{ display:"inline-block", width:14, height:14, border:"2px solid rgba(255,255,255,0.35)", borderTopColor:"white", borderRadius:"50%", animation:"setrag-spin 0.6s linear infinite", marginRight:8, verticalAlign:"middle" }} />;
const TrainIcon  = () => <svg width="28" height="28" viewBox="0 0 24 24" fill="none"><rect x="4" y="3" width="16" height="13" rx="2" stroke="currentColor" strokeWidth="1.6"/><path d="M4 10h16M8 16l-2 4M16 16l2 4M9 10V6M15 10V6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><circle cx="8.5" cy="13.5" r="1" fill="currentColor"/><circle cx="15.5" cy="13.5" r="1" fill="currentColor"/></svg>;

/* ═══════════════════════════════════════
   FORCE MOT DE PASSE
═══════════════════════════════════════ */
const pwStrength = (p) => {
  if (!p) return { score:0, label:"", color:C.grayBd };
  let score = 0;
  if (p.length >= 8)           score++;
  if (/[A-Z]/.test(p))         score++;
  if (/[0-9]/.test(p))         score++;
  if (/[^A-Za-z0-9]/.test(p))  score++;
  const map = [
    { label:"", color:C.grayBd },
    { label:"Faible",    color:"#f87171" },
    { label:"Moyen",     color:"#fbbf24" },
    { label:"Bon",       color:"#34d399" },
    { label:"Excellent", color:C.green },
  ];
  return { score, ...map[score] };
};

/* ═══════════════════════════════════════
   PANEL GAUCHE – THÈME SETRAG
═══════════════════════════════════════ */
const PanelLeft = () => (
  <div style={s.panel} className="setrag-panel">
    <svg style={s.panelBg} viewBox="0 0 440 800" preserveAspectRatio="xMidYMid slice">
      <defs>
        <pattern id="rail-grid2" width="44" height="44" patternUnits="userSpaceOnUse">
          <path d="M 44 0 L 0 0 0 44" fill="none" stroke="rgba(255,255,255,0.04)" strokeWidth="0.6"/>
        </pattern>
      </defs>
      <rect width="440" height="800" fill="url(#rail-grid2)"/>
      <circle cx="60"  cy="200" r="200" fill="rgba(255,195,0,0.04)"/>
      <circle cx="380" cy="620" r="170" fill="rgba(255,195,0,0.05)"/>
      {/* Rails */}
      <g opacity="0.1">
        <line x1="55"  y1="0" x2="55"  y2="800" stroke="#FFC300" strokeWidth="1.5"/>
        <line x1="90"  y1="0" x2="90"  y2="800" stroke="#FFC300" strokeWidth="1.5"/>
        {[70,150,230,310,390,470,550,630,710].map(y => (
          <line key={y} x1="48" y1={y} x2="97" y2={y} stroke="#FFC300" strokeWidth="3"/>
        ))}
      </g>
      <g opacity="0.06">
        <line x1="350" y1="0" x2="350" y2="800" stroke="#FFC300" strokeWidth="1.2"/>
        <line x1="382" y1="0" x2="382" y2="800" stroke="#FFC300" strokeWidth="1.2"/>
        {[50,130,210,290,370,450,530,610,690].map(y => (
          <line key={y} x1="343" y1={y} x2="389" y2={y} stroke="#FFC300" strokeWidth="2.5"/>
        ))}
      </g>
    </svg>

    <div style={s.panelContent}>
      <div style={s.panelLogo}>
        <span style={{ color:C.yellow }}><TrainIcon /></span>
        <div>
          <div style={{ fontWeight:800, fontSize:20, letterSpacing:2 }}>SETRAG</div>
          <div style={{ fontSize:10, color:"rgba(255,255,255,0.5)", letterSpacing:3 }}>TRANSGABONAIS</div>
        </div>
      </div>

      <div style={{ margin:"auto 0" }}>
        <div style={{ display:"inline-block", background:"rgba(255,195,0,0.15)", border:"1px solid rgba(255,195,0,0.3)", borderRadius:20, padding:"4px 14px", fontSize:11, color:C.yellow, marginBottom:16, letterSpacing:1 }}>
          🇬🇦 Nouveau voyageur
        </div>
        <h2 style={s.panelTitle}>Rejoignez la communauté SETRAG</h2>
        <p style={s.panelSub}>
          Accédez aux meilleurs trajets entre Libreville et Franceville, réservez en ligne et voyagez en toute sérénité.
        </p>
      </div>

      {/* Avantages */}
      <ul style={s.checklist}>
        {[
          ["🎟️","Réservation en ligne en 2 minutes"],
          ["📱","Billet numérique sur votre téléphone"],
          ["💺","Choix du siège garanti"],
          ["🛡️","Paiement sécurisé Mobile Money"],
        ].map(([icon, item]) => (
          <li key={item} style={s.checkItem}>
            <span style={{ fontSize:16, flexShrink:0 }}>{icon}</span>
            <span style={{ fontSize:13, color:"rgba(255,255,255,0.55)", lineHeight:1.5 }}>{item}</span>
          </li>
        ))}
      </ul>

      {/* Stats */}
      <div style={s.panelStats}>
        {[["9 204","Trajets"],["138","Trains"],["4.8★","Satisfaction"]].map(([v, l]) => (
          <div key={l} style={{ textAlign:"center" }}>
            <div style={s.statVal}>{v}</div>
            <div style={s.statLabel}>{l}</div>
          </div>
        ))}
      </div>
    </div>
  </div>
);

/* ═══════════════════════════════════════
   COMPOSANT FIELD
═══════════════════════════════════════ */
const Field = ({ label, icon, error, style: fieldStyle, ...inputProps }) => (
  <div style={fieldStyle}>
    {label && <label style={s.label}>{label}</label>}
    <div style={{ position:"relative" }}>
      {icon && <span style={s.inputIcon}>{icon}</span>}
      <input
        style={{ ...s.input, paddingLeft: icon ? 42 : 14, borderColor: error ? "#f87171" : undefined }}
        {...inputProps}
      />
    </div>
    {error && <div style={s.fieldError}>{error}</div>}
  </div>
);

/* ═══════════════════════════════════════
   PAGE REGISTER
═══════════════════════════════════════ */
const Register = () => {
  const navigate  = useNavigate();
  const { login } = useAuth();

  const [form, setForm] = useState({
    firstName:"", lastName:"", email:"",
    phone:"", password:"", confirmPassword:"",
  });
  const [authMethod,  setAuthMethod] = useState("email"); // "email" | "phone" - un seul choix à la fois, pour éviter la confusion
  const [loading,     setLoading]  = useState(false);
  const [error,       setError]    = useState("");
  const [showPwd,     setShowPwd]  = useState(false);
  const [showCPwd,    setShowCPwd] = useState(false);
  const [fieldErrors, setFE]       = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(f => ({ ...f, [name]:value }));
    setFE(fe => ({ ...fe, [name]:"" }));
  };

  const switchAuthMethod = (method) => {
    setAuthMethod(method);
    // On vide le champ non utilisé pour ne jamais envoyer une valeur
    // oubliée/incohérente avec le mode choisi.
    setForm(f => ({ ...f, [method === "email" ? "phone" : "email"]: "" }));
    setFE(fe => ({ ...fe, email:"", phone:"" }));
  };

  const validate = () => {
    const errs = {};
    if (!form.firstName.trim())    errs.firstName = "Requis";
    if (!form.lastName.trim())     errs.lastName  = "Requis";

    if (authMethod === "email") {
      if (!form.email.trim())          errs.email = "L'email est requis";
      else if (!form.email.includes("@")) errs.email = "Email invalide";
    } else {
      if (!form.phone.trim())          errs.phone = "Le téléphone est requis";
      else if (form.phone.replace(/\D/g,"").length < 8) errs.phone = "Numéro de téléphone invalide";
    }

    if (form.password.length < 6)  errs.password  = "6 caractères minimum";
    if (form.password !== form.confirmPassword) errs.confirmPassword = "Les mots de passe ne correspondent pas";
    return errs;
  };

  const handleRegister = async () => {
    setError("");
    const errs = validate();
    if (Object.keys(errs).length) { setFE(errs); return; }
    setLoading(true);
    try {
      const res = await api.post("/register", {
        firstName:form.firstName, lastName:form.lastName,
        email:form.email, phone:form.phone, password:form.password,
      });
      login(res.data.token, null, res.data.user);
      // On transmet l'email ET le téléphone : la page de vérification utilise
      // l'un ou l'autre selon celui qui a été renseigné à l'inscription.
      navigate("/verify-account", { state: { email: form.email, phone: form.phone } });
    } catch {
      setError("Erreur lors de l'inscription. Cet email ou ce numéro est peut-être déjà utilisé.");
    }
    setLoading(false);
  };

  const strength = pwStrength(form.password);

  return (
    <>
      <PublicNav />
      <div style={s.page}>
        <style>{globalCSS}</style>
        <PanelLeft />

        <div style={s.formSide}>
          <div style={{ ...s.formBox, maxWidth:460 }}>

          {/* Mobile logo */}
          <div style={{ display:"flex", alignItems:"center", gap:10, marginBottom:24, paddingBottom:20, borderBottom:`1px solid ${C.grayBd}` }}>
            <div style={{ width:36, height:36, borderRadius:10, background:C.greenLt, display:"flex", alignItems:"center", justifyContent:"center" }}>
              <span style={{ color:C.green }}><TrainIcon /></span>
            </div>
            <div>
              <div style={{ fontWeight:800, fontSize:14, color:C.green, letterSpacing:1 }}>SETRAG</div>
              <div style={{ fontSize:10, color:C.textSub, letterSpacing:2 }}>TRANSGABONAIS</div>
            </div>
          </div>

          <div style={s.formHeader}>
            <h1 style={s.formTitle}>Créer un compte voyageur</h1>
            <p style={s.formSub}>
              Déjà inscrit ?{" "}
              <Link to="/login" style={s.link}>Se connecter</Link>
            </p>
          </div>

          {error && <div style={s.errorBox}><AlertIcon />{error}</div>}

          {/* NOMS */}
          <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12, marginBottom:14 }}>
            <Field label="Prénom" icon={<UserIcon />} name="firstName" placeholder="Votre prénom" value={form.firstName} onChange={handleChange} error={fieldErrors.firstName} />
            <Field label="Nom"    icon={<UserIcon />} name="lastName"  placeholder="Votre nom"    value={form.lastName}  onChange={handleChange} error={fieldErrors.lastName}  />
          </div>

          {/* CHOIX DU MODE D'INSCRIPTION */}
          <div style={{ marginBottom:14 }}>
            <label style={s.label}>Je préfère m'inscrire avec</label>
            <div style={{ display:"flex", gap:8 }}>
              {[["email","Mon email"],["phone","Mon téléphone"]].map(([val,lbl]) => (
                <button key={val} type="button" onClick={() => switchAuthMethod(val)}
                  style={{
                    flex:1, padding:"10px 12px", borderRadius:10, fontWeight:700, fontSize:13, cursor:"pointer",
                    border:`1.5px solid ${authMethod===val ? C.green : C.grayBd}`,
                    background: authMethod===val ? C.greenLt : "#fff",
                    color: authMethod===val ? C.green : C.textSub,
                  }}>
                  {authMethod===val && "✓ "}{lbl}
                </button>
              ))}
            </div>
          </div>

          {authMethod === "email" ? (
            <Field label="Adresse email" icon={<MailIcon />} name="email" type="email"
              placeholder="vous@exemple.ga" value={form.email} onChange={handleChange}
              error={fieldErrors.email} style={{ marginBottom:14 }} />
          ) : (
            <Field label="Téléphone" icon={<PhoneIcon />} name="phone" type="tel"
              placeholder="+241 07 XX XX XX" value={form.phone} onChange={handleChange}
              error={fieldErrors.phone} style={{ marginBottom:14 }} />
          )}

          {/* MOT DE PASSE */}
          <div style={{ marginBottom:6 }}>
            <label style={s.label}>Mot de passe</label>
            <div style={{ position:"relative" }}>
              <span style={s.inputIcon}><LockIcon /></span>
              <input
                style={{ ...s.input, paddingLeft:42, paddingRight:42, borderColor:fieldErrors.password ? "#f87171" : undefined }}
                type={showPwd ? "text" : "password"}
                name="password"
                placeholder="Minimum 6 caractères"
                value={form.password}
                onChange={handleChange}
              />
              <button style={s.eyeBtn} type="button" onClick={() => setShowPwd(!showPwd)}>
                {showPwd ? <EyeOffIcon /> : <EyeIcon />}
              </button>
            </div>
            {fieldErrors.password && <div style={s.fieldError}>{fieldErrors.password}</div>}
          </div>

          {/* Barre de force */}
          {form.password && (
            <div style={{ marginBottom:14 }}>
              <div style={{ display:"flex", gap:4, marginBottom:4 }}>
                {[1,2,3,4].map(i => (
                  <div key={i} style={{ flex:1, height:4, borderRadius:2, background:i <= strength.score ? strength.color : C.grayBd, transition:"background 0.2s" }} />
                ))}
              </div>
              <div style={{ fontSize:11, color:strength.color, fontWeight:600 }}>{strength.label}</div>
            </div>
          )}

          {/* CONFIRMATION */}
          <div style={{ marginBottom:24 }}>
            <label style={s.label}>Confirmer le mot de passe</label>
            <div style={{ position:"relative" }}>
              <span style={s.inputIcon}><LockIcon /></span>
              <input
                style={{
                  ...s.input, paddingLeft:42, paddingRight:42,
                  borderColor:fieldErrors.confirmPassword ? "#f87171"
                    : (form.confirmPassword && form.password === form.confirmPassword ? C.green : undefined),
                }}
                type={showCPwd ? "text" : "password"}
                name="confirmPassword"
                placeholder="Répétez votre mot de passe"
                value={form.confirmPassword}
                onChange={handleChange}
              />
              <button style={s.eyeBtn} type="button" onClick={() => setShowCPwd(!showCPwd)}>
                {showCPwd ? <EyeOffIcon /> : <EyeIcon />}
              </button>
            </div>
            {fieldErrors.confirmPassword && <div style={s.fieldError}>{fieldErrors.confirmPassword}</div>}
            {form.confirmPassword && form.password === form.confirmPassword && !fieldErrors.confirmPassword && (
              <div style={{ display:"flex", alignItems:"center", gap:5, marginTop:5, fontSize:11, color:C.green, fontWeight:600 }}>
                <CheckIcon /> Mots de passe identiques
              </div>
            )}
          </div>

          <button style={s.submitBtn} onClick={handleRegister} disabled={loading} className="setrag-btn">
            {loading ? <><SpinIcon />Inscription en cours…</> : "Créer mon compte SETRAG"}
          </button>

          <p style={{ fontSize:11, color:C.textSub, textAlign:"center", marginTop:14, lineHeight:1.6 }}>
            En créant un compte, vous acceptez nos{" "}
            <Link to="/conditions" style={{ color:C.green }}>Conditions d'utilisation</Link>
            {" "}et notre{" "}
            <Link to="/confidentialite" style={{ color:C.green }}>Politique de confidentialité</Link>.
          </p>

          <div style={s.divider}><span style={s.dividerText}>déjà un billet à gérer ?</span></div>
          <Link to="/login" style={s.altBtn}>
            <span>🔑</span> Se connecter à mon compte
          </Link>
        </div>
      </div>
      </div>
    </>
  );
};

export default Register;

/* ── Styles ── */
const s = {
  page:        { display:"flex", minHeight:"100vh", fontFamily:"'Segoe UI', sans-serif" },
  panel:       { width:"42%", background:C.greenDk, position:"relative", overflow:"hidden", flexShrink:0 },
  panelBg:     { position:"absolute", inset:0, width:"100%", height:"100%" },
  panelContent:{ position:"relative", zIndex:1, display:"flex", flexDirection:"column", height:"100%", padding:"36px 40px" },
  panelLogo:   { display:"flex", alignItems:"center", gap:8, color:"#fff", marginBottom:"auto" },
  panelTitle:  { fontSize:28, fontWeight:800, color:"#fff", letterSpacing:-0.5, lineHeight:1.2, marginBottom:12 },
  panelSub:    { fontSize:14, color:"rgba(255,255,255,0.55)", lineHeight:1.75 },
  checklist:   { listStyle:"none", padding:0, margin:"28px 0", display:"flex", flexDirection:"column", gap:12 },
  checkItem:   { display:"flex", alignItems:"flex-start", gap:10 },
  panelStats:  { display:"flex", gap:0, paddingTop:20, borderTop:"1px solid rgba(255,255,255,0.08)", justifyContent:"space-around", marginTop:"auto" },
  statVal:     { fontSize:17, fontWeight:800, color:"#fff" },
  statLabel:   { fontSize:10, color:"rgba(255,255,255,0.4)", marginTop:2 },

  formSide:    { flex:1, display:"flex", alignItems:"flex-start", justifyContent:"center", background:C.gray, padding:"40px 32px", overflowY:"auto" },
  formBox:     { width:"100%", maxWidth:460, paddingTop:16 },
  formHeader:  { marginBottom:24 },
  formTitle:   { fontSize:24, fontWeight:800, color:C.text, margin:"0 0 6px", letterSpacing:-0.5 },
  formSub:     { fontSize:13, color:C.textSub, margin:0 },
  link:        { color:C.green, fontWeight:700, textDecoration:"none" },
  errorBox:    { display:"flex", alignItems:"center", gap:8, background:"#fff5f5", border:"1px solid #fecaca", borderRadius:10, padding:"10px 14px", marginBottom:18, fontSize:13, color:"#dc2626" },
  fieldError:  { fontSize:11, color:"#f87171", marginTop:4 },
  label:       { display:"block", fontSize:11, fontWeight:700, color:C.textSub, marginBottom:6, textTransform:"uppercase", letterSpacing:0.5 },
  input:       { width:"100%", padding:"12px 14px", border:`1.5px solid ${C.grayBd}`, borderRadius:10, fontSize:14, fontFamily:"inherit", color:C.text, background:"#fff", outline:"none", boxSizing:"border-box", transition:"border-color 0.15s" },
  inputIcon:   { position:"absolute", left:14, top:"50%", transform:"translateY(-50%)", display:"flex", alignItems:"center", pointerEvents:"none" },
  eyeBtn:      { position:"absolute", right:12, top:"50%", transform:"translateY(-50%)", background:"none", border:"none", cursor:"pointer", padding:4, display:"flex", alignItems:"center" },
  submitBtn:   { width:"100%", padding:"13px 0", background:`linear-gradient(135deg, ${C.green}, ${C.greenMid})`, color:"#fff", border:"none", borderRadius:10, fontSize:15, fontWeight:700, cursor:"pointer", fontFamily:"inherit", display:"flex", alignItems:"center", justifyContent:"center", gap:6, letterSpacing:0.3 },
  divider:     { position:"relative", textAlign:"center", margin:"20px 0", borderTop:`1px solid ${C.grayBd}` },
  dividerText: { position:"absolute", top:"50%", left:"50%", transform:"translate(-50%,-50%)", background:C.gray, padding:"0 12px", fontSize:11, color:C.textSub, whiteSpace:"nowrap" },
  altBtn:      { display:"flex", alignItems:"center", justifyContent:"center", gap:8, padding:"12px 0", border:`1.5px solid ${C.grayBd}`, borderRadius:10, fontSize:13, color:C.text, textDecoration:"none", fontWeight:600, background:"#fff" },
};

const globalCSS = `
  @keyframes setrag-spin { to { transform: rotate(360deg); } }
  input:focus { border-color: #006B3C !important; box-shadow: 0 0 0 3px rgba(0,107,60,0.1) !important; }
  .setrag-btn:hover:not(:disabled) { opacity: 0.9; transform: translateY(-1px); }
  .setrag-btn:disabled { opacity: 0.6; cursor: not-allowed; }
  .setrag-btn { transition: all 0.15s ease; }
  @media (max-width: 768px) { .setrag-panel { display: none !important; width: 0 !important; } }
`;